import { Component } from "react";
import React from "react";
import ContextMenu from "./ContextMenu";
import { constants } from "../../../../utils/Constants";
import SecurityUtils from "../../../../utils/SecurityUtils";

class ContextMenuContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contextMenu: {
        index: undefined,
        visible: false,
        x: 0,
        y: 0,
        menu: []
      }
    };
  }

  outsideClickListener = event => {
    event.stopPropagation();
    const visible = this.state.contextMenu.visible;
    if (visible) {
      this.setState({
        contextMenu: {
          index: undefined,
          visible: false,
          x: 0,
          y: 0,
          menu: []
        }
      });
    }
  };

  componentDidMount() {
    document.addEventListener("click", this.outsideClickListener);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.outsideClickListener);
  }

  onSubmit = event => {
    const targetId = parseInt(event.currentTarget.id);
    if (this.state.contextMenu.menu[targetId].callback) {
      this.state.contextMenu.menu[targetId].callback(
        this.state.contextMenu.index
      );
    }
  };

  setContextMenu(contextMenuItems, event, row) {
    contextMenuItems = contextMenuItems.filter(item => {
      switch (item.menuItemType) {
        case constants.MENU_ITEM_TYPE_REACTIVATE:
          if (item.checkSecurity) {
            return (
              SecurityUtils.userHasPermissionOnEntity(
                row,
                constants.OPERATION_DELETE
              ) && !row.active
            );
          } else {
            return !row.active;
          }
        case constants.MENU_ITEM_TYPE_DELETE:
          if (item.checkSecurity) {
            return (
              SecurityUtils.userHasPermissionOnEntity(
                row,
                constants.OPERATION_DELETE
              ) && row.active
            );
          } else {
            return row.active;
          }
        default:
          return true;
      }
    });
    const { contextMenu } = this.state;
    contextMenu.menu = contextMenuItems;
    contextMenu.visible = true;
    contextMenu.x = event.pageX;
    contextMenu.y = event.pageY;
    contextMenu.index = row;
    this.setState({ contextMenu });
  }

  render() {
    return (
      <ContextMenu
        contextMenu={this.state.contextMenu}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default ContextMenuContainer;
